import { Component, HostListener, Inject, OnInit } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import { User } from "@mitel/cloudlink-sdk";
import { IntegTwilioSmsNumbersService } from "src/app/core/services/integ-twilio-sms-numbers.service";
import { SmsNumberOperation } from "src/app/core/services/users-bulk-edit-sms-numbers.service";

@Component({
  selector: "app-sms-numbers-multi-edit-dialog",
  templateUrl: "./sms-numbers-multi-edit-dialog.component.html",
  styleUrls: ["./sms-numbers-multi-edit-dialog.component.scss"],
})
export class SmsNumbersMultiEditDialogComponent implements OnInit {
  users: User[] = [];
  product: any;
  applyToAll: boolean;
  accountId: string;
  loading: boolean = true;
  smsNumber: FormControl<SmsNumberOperation> = new FormControl(SmsNumberOperation.unchanged, [Validators.required]);
  numberOptions = [SmsNumberOperation.unchanged];
  availableSmsNumbers: string[] = [];
  usersWithNumbersAssigned: User[] = [];
  submitted: boolean = false;
  longOperationInProgress = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<SmsNumbersMultiEditDialogComponent>,
		private matIconRegistry: MatIconRegistry,
		private domSanitizer: DomSanitizer,
    private integTwilioSmsNumbersService: IntegTwilioSmsNumbersService,
  ) {
    this.product = data.product;
    this.users = data.users;
    this.applyToAll = data.applyToAll;
    this.accountId = data.accountId;
    this.matIconRegistry.addSvgIcon(
      'blue-info-solid',
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/images/blue-info-solid.svg")
    );
    this.matIconRegistry.addSvgIcon(
      'red-info-solid',
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/images/info-solid-error-600.svg")
    );
  }

  // to give the user the option to not close the page
  // when a lengthy operation is in progress`
  @HostListener('window:beforeunload', ['$event'])
  unloadNotification(event: any) {
    console.log("Browser page unload detected", event);
    if (this.longOperationInProgress === true) {
      event.preventDefault(); // If you prevent default behavior in Mozilla Firefox prompt will always be shown
      // Chrome requires returnValue to be set
      event.returnValue = false;
    }
  }

  ngOnInit() {
    this.getRequiredInformation().then(() => {
      this.loading = false;
    });
  }

  async getRequiredInformation() {
    let promises = [];

    promises.push(this.integTwilioSmsNumbersService.getListOfAvailableSmsNumbers().then(availableSmsNumbers => this.availableSmsNumbers = availableSmsNumbers));
    if (this.applyToAll) {
      promises.push(this.integTwilioSmsNumbersService.getListOfUsersWithSmsNumberAssigned(this.accountId).then((users) => this.usersWithNumbersAssigned = users));
    } else {
      this.usersWithNumbersAssigned = this.users.filter( user=>user.tags?.smsIntegration?.number );
    }

    await Promise.all(promises);
    if (this.usersWithNumbersAssigned.length > 0) {
      this.numberOptions.push(SmsNumberOperation.unassignAll);
    }
    if (this.users.length != this.usersWithNumbersAssigned.length && this.users.length <= (this.usersWithNumbersAssigned.length + this.availableSmsNumbers.length)) {
      this.numberOptions.push(SmsNumberOperation.assignAll);
    }
  }

  isFormValueChanged(): boolean {
    return this.smsNumber.value !== SmsNumberOperation.unchanged;
  }

  onSave() {
    this.submitted = true;
    this.longOperationInProgress = true;
    this.product.service.saveUserTwilioSmsNumberBulkOperation(
      this.accountId,
      this.smsNumber.value == SmsNumberOperation.unassignAll ? this.usersWithNumbersAssigned : this.users,
      this.smsNumber.value
    ).then(result => {
      this.longOperationInProgress = false;
      this.dialogRef.close({ reason: "resetUsers" });
    });
  }

  onCancel() {
    this.dialogRef.close();
  }

  getNumberSummary() {
    if (this.users.length > (this.usersWithNumbersAssigned.length + this.availableSmsNumbers.length)) {
      return {
        available: this.availableSmsNumbers.length,
        used: this.usersWithNumbersAssigned.length,
        missing: this.users.length - (this.usersWithNumbersAssigned.length + this.availableSmsNumbers.length),
        style: 'red',
        icon: 'red-info-solid',
      };
    } else {
      return {
        available: this.availableSmsNumbers.length,
        used: this.usersWithNumbersAssigned.length,
        style: 'blue',
        icon: 'blue-info-solid',
      };
    }
  }
}